// functions/amazonAffiliate/affiliateDefaults.js
/*
AFFILIATE_DATA.push({
  title: "",
  url: "",
  image: "",
  comment:"",
});
*/

export const AFFILIATE_DATA = [
  {
    title: "熊スプレー",
    url: "https://amzn.to/42XCryf",
    image: "https://m.media-amazon.com/images/I/61RWcpS1NDL._AC_SX425_.jpg",
    comment:"クマ出没注意！\nもしもの安心ために１個は持っておきたい",
  },
  {
    title: "いろはす",
    url: "https://amzn.to/4qr8iS5",
    image: "https://m.media-amazon.com/images/I/61WSLyLPRTL._AC_SX679_PIbundle-24,TopRight,0,0_SH20_.jpg",
    comment:"水分足りてる？いろはすで手軽に補給！",
  },
  {
    title: "プロテイン",
    url: "https://amzn.to/47qmPVh",
    image: "https://m.media-amazon.com/images/I/81ez83BNLcL._AC_SX466_.jpg",
  comment:"最近筋トレしてる？\nプロテインで効率的に筋肉をサポート！",
  },
  {
    title: "PCモニター",
    url: "https://amzn.to/4qt9tAe",
    image: "https://m.media-amazon.com/images/I/71f4BinbCqL._AC_SX679_.jpg",
  comment:"今あなたが使っているモニター、大丈夫？\n目に優しい高品質モニターで作業効率アップ！",
  },
   {
    title: "金属製フィジェットトイ",
    url: "https://www.amazon.co.jp/dp/B0CW676PQT?tag=aoistoy07-22",
    image: "https://m.media-amazon.com/images/I/71PVC8APh9L._AC_SY450_.jpg",
    comment: "純金属製でずっしり手にくるフィジェットトイ。\n触り心地がよく、無意味に回してしまう中毒性あり。"
  },
  {
    title: "ニキビ スクイーズ飛び出すおもちゃ",
    url: "https://www.amazon.co.jp/dp/B0FSL16G69?tag=aoistoy07-22",
    image: "https://m.media-amazon.com/images/I/519mfMRZ98L._AC_SX425_.jpg",
    comment: "エイリアン型のポップトイを押すと\n“にきび”のようにポコっと出てくる不思議おもちゃ。"
  },
  {
    title: "モーションセンサー付きLEDトイレ夜ライト",
    url: "https://www.amazon.co.jp/dp/B07C44HF7N?tag=aoistoy07-22",
    image: "https://m.media-amazon.com/images/I/61e5MO3SaTL._AC_SX466_.jpg",
    comment: "暗闇で9色に光るトイレライト。\n動きを感知して点灯、夜中も安心＆おしゃれ。"
  },
  {
    title: "鍵を隠す偽ロック石",
    url: "https://www.amazon.co.jp/dp/B01DSMSJGI?tag=aoistoy07-22",
    image: "https://m.media-amazon.com/images/I/81FtkfFR+rL._AC_SX425_.jpg",
    comment: "本物の石そっくりに見えるが中に鍵を隠せる。\n隠す楽しさ＋ジョーク感覚で使える。"
  },
  {
    title: "Apple AirTag（1パック）",
    url: "https://amzn.to/4pmoS3Z",
    image: "https://m.media-amazon.com/images/I/71PvOS6LRnL._AC_SX466_.jpg",
    comment: "大事なものを見失わせない紛失防止タグ。\niPhoneとの相性抜群。"
  }
  ,
  {
    title: "リアル魚型抱き枕",
    url: "https://amzn.to/49z3rIz",
    image: "https://m.media-amazon.com/images/I/51nY9V-IqFL._AC_SX425_.jpg",
    comment: "見た目がリアルな魚型！\n抱き心地ふわふわでネタ系にも最適な抱き枕。"
  },
  {
    title: "自動撹拌マグカップ",
    url: "https://amzn.to/4rgIbxy",
    image: "https://m.media-amazon.com/images/I/51+e2zMPcaL._AC_SX425_.jpg",
    comment: "ワンタッチで中身を自動でかき混ぜるマグ。\n忙しい朝やコーヒー好きに最適。"
  },
  {
    title: "LED光るキャップ",
    url: "https://amzn.to/3JSpHmh",
    image: "https://m.media-amazon.com/images/I/71M3h366mAS._AC_SX679_.jpg",
    comment: "文字が光るLED搭載のキャップ。\nパーティーや応援で目立つインパクト大のアイテム。"
  },
  {
    title: "爆笑3D変装エプロン",
    url: "https://www.amazon.co.jp/dp/B07CXTFT8L?tag=aoistoy07-22",
    image: "https://m.media-amazon.com/images/I/618nEUco3vL._AC_SX679_.jpg",
    comment: "リアル体型プリントのエプロン。\nBBQやパーティーで盛り上がるネタアイテム。"
  },
  {
    title: "超低収縮 3Dプリンタ用レジン",
    url: "https://www.amazon.co.jp/dp/B0BQHHJGQB?tag=aoistoy07-22",
    image: "https://m.media-amazon.com/images/I/61q7T1Kq2oL._AC_SX425_.jpg",
    comment: "精密造形が可能な低収縮レジン。\n3Dプリンタ愛好者に嬉しい精密素材。"
  },
  {
    title: "LED付きスマートリモコン",
    url: "https://www.amazon.co.jp/dp/B0BM8VS13P?tag=aoistoy07-22",
    image: "https://m.media-amazon.com/images/I/61uOJuxDPdL._AC_SY450_.jpg",
    comment: "スマホや音声で家電操作。\n便利でスマートホーム初心者にもおすすめ。"
  },
  {
    title: "超臨界スリッパ",
    url: "https://amzn.to/4r6ZxwG",
    image: "https://m.media-amazon.com/images/I/71OhjA1vEZL._AC_SY625_.jpg",
    comment: "履いた感覚が不思議。\nまるで足が浮いてるような感覚の話題性抜群スリッパ。"
  },
  {
    title: "リアル野球モチーフピアス",
    url: "https://www.amazon.co.jp/dp/B0FS1BD3M7?tag=aoistoy07-22",
    image: "https://m.media-amazon.com/images/I/71fVX1bewZL._AC_SX679_.jpg",
    comment: "ステンレス＆純銀使用。\nスポーツ好きへのネタ兼おしゃれギフトにぴったり。"
  },
  {
    title: "野球モチーフユニークイヤリング",
    url: "https://www.amazon.co.jp/dp/B0FK4FTDC6?tag=aoistoy07-22",
    image: "https://m.media-amazon.com/images/I/71ZlUrQQEsL._AC_SX679_.jpg",
    comment: "天然木と合金を組み合わせた野球ボール型イヤリング。\nユーモアとおしゃれを両立。"
  },
  {
    title: "SwitchBot 温湿度計付きスマートリモコン",
    url: "https://www.amazon.co.jp/dp/B0DWDQYLXG?tag=aoistoy07-22",
    image: "https://m.media-amazon.com/images/I/61J9tu63OUL._AC_SY450_.jpg",
    comment: "温度湿度センサーと\n赤外線制御を兼ね備えたハイエンドモデル。\n快適な室内環境を自動制御。"
  },
  {
    title: "Anker Nebula Capsule プロジェクター",
    url: "https://amzn.to/3MiL1Ss",
    image: "https://m.media-amazon.com/images/I/51fywU7gzvL._AC_SY679_.jpg",
    comment: "手のひらサイズで映画やプレゼンが可能。\nキャンプやお泊まり会で大活躍。"
  },
  {
    title: "パナソニック 目もとエステ EH-SW67",
    url: "https://amzn.to/3KiBLxa",
    image: "https://m.media-amazon.com/images/I/51odgEGBUPL._AC_SX425_.jpg",
    comment: "温感＆振動で目の疲れをほぐす。\nリラックスタイムに最適。"
  },
  {
    title: "マグネット式シリコン充電ケーブル",
    url: "https://www.amazon.co.jp/dp/B0CXDXDLJS?tag=aoistoy07-22",
    image: "https://m.media-amazon.com/images/I/51CVh42r3UL._AC_SX425_.jpg",
    comment: "磁石でピタッと接続。\n液晶表示で電力状況も確認できる未来感あるケーブル。"
  },

  {
    title: "本型金庫（辞書型セーフティーボックス）",
    url: "https://www.amazon.co.jp/dp/B0D4F2S4CQ?tag=aoistoy07-22",
    image: "https://m.media-amazon.com/images/I/717DG8GeZhS._AC_SY450_.jpg",
    comment: "まるで本棚にある辞書に見える金庫。\n見た目を隠しつつ、貴重品を安全に保管できる\n遊び心のある防犯グッズ。"
  },
  {
    title: "フリッジィズー24 冷蔵庫 ガジェット（シロクマ）",
    url: "https://www.amazon.co.jp/dp/B00NSAZJF0?tag=aoistoy07-22",
    image: "https://m.media-amazon.com/images/I/31Z6EVSbqgL._AC_SX425_.jpg",
    comment: "冷蔵庫の中に入れておくと、\n小さなシロクマが話しかけてくれる癒しガジェット。"
  },
  {
    title: "フリッジィズー24 冷蔵庫 ガジェット（ペンギン）",
    url: "https://www.amazon.co.jp/dp/B00NSB5EEU?tag=aoistoy07-22",
    image: "https://m.media-amazon.com/images/I/41OrjZ1ukPL._AC_SX425_.jpg",
    comment: "かわいいペンギンが冷蔵庫の中でおしゃべり。\n遊び心があって、冷蔵庫を開けるたびに\nちょっと嬉しくなる小型ガジェット。"
  },
  {
    title: "フリッジィズー24 冷蔵庫 ガジェット（ウシ）",
    url: "https://www.amazon.co.jp/dp/B00NSB9HL6?tag=aoistoy07-22",
    image: "https://m.media-amazon.com/images/I/51d+NrSKVvL._AC_SX425_.jpg",
    comment: "ウシのキャラクターが冷蔵庫の中で\n時間帯に応じて話す。\n不思議な存在感と癒しを兼ね備えたガジェット。"
  },
  {
    title: "クリーニングジェル スライム（キーボード・車内用）",
    url: "https://www.amazon.co.jp/dp/B0BGF725QC?tag=aoistoy07-22",
    image: "https://m.media-amazon.com/images/I/71jbJdk9r6L._AC_SY300_SX300_QL70_ML2_.jpg",
    comment: "PCキーボードや車の隙間のホコリを\nスライム状ジェルで捕まえる。\n使い終わって戻すだけの手軽掃除アイテム。"
  },
  {
    title: "クリーニングジェル スライム（ 160g）",
    url: "https://www.amazon.co.jp/dp/B086MHFV2P?tag=aoistoy07-22",
    image: "https://m.media-amazon.com/images/I/71vAs58Jd9L._AC_SX425_.jpg",
    comment: "ほのかな香りつきの粘着クリーナー。\n粘土みたいに伸ばしてホコリをどんどん吸着、\n繰り返し使えてコスパも良い。"
  },
  {
    title: "TICARVE ジェルクリーナー スライム（車内・キーボード用）",
    url: "https://www.amazon.co.jp/dp/B09FLZ58M5?tag=aoistoy07-22",
    image: "https://m.media-amazon.com/images/I/719ZAE80bIL._AC_SX425_.jpg",
    comment: "天然系素材を使った\n車内・キーボード掃除用ジェル。\n細かい隙間の汚れをくまなく掃除できる異色クリーナー。"
  },

  {
    title: "多面体ポモドーロタイマー（Time Cube）",
    url: "https://amzn.to/4iglVzz",  // ASIN例、要確認
    image: "https://m.media-amazon.com/images/I/71NwfZtXZJL._AC_SX425_.jpg",
    comment: "立方体を転がすだけでタイマーがスタート。\n勉強や仕事を儀式化するおもしろガジェット。"
  },
  {
    title: "SALONIA  洗顔ブラシ",
    url: "https://amzn.to/4onkxgk",  // ASIN例、要確認
    image: "https://m.media-amazon.com/images/I/51IAHKw24IS._AC_SX425_.jpg",
    comment: "振動で毛穴の奥まで洗浄。\n肌に優しい設計で\n毎日のスキンケアが楽しくなるアイテム。"
  },
  {
    title: "スタープロジェクターライト ベッドサイドランプ",
    url: "https://amzn.to/4pp9kwv",  // ASIN例、要確認
    image: "https://m.media-amazon.com/images/I/71I9T5JUzKL._AC_SX466_.jpg",
    comment: "家庭用プラネタリウム。\n星空や宇宙空間を部屋に再現し、\nリラックス効果抜群のムードライト。"
  },
  {
    title: "フライングボール DEERC おもちゃ UFO ミニドローン",
    url: "https://amzn.to/4rgNzRf",  // ASIN例、要確認
    image: "https://m.media-amazon.com/images/I/71EIimfPTuL._AC_SX425_.jpg",
    comment: "手の上や机の上でホバリング。\n遊びながら癒される、不思議感あふれる。"
  },
  {
    title: "サイコロストレージケースフォーRPGダイス",
    url: "https://amzn.to/47TKIpO",  // ASIN例、要確認
    image: "https://m.media-amazon.com/images/I/71n2cQbuaZL._AC_SX425_.jpg",
    comment: "スタイリッシュなサイコロと\n高級感のあるケース。"
  },
  {
    title: "Divoom Times Gate デジタルデコクロック 近未来 サイバーライト",
    url: "https://amzn.to/4ocnBf0",  // ASIN例、要確認
    image: "https://m.media-amazon.com/images/I/71HOMZAYfeL._AC_SX425_.jpg",
    comment: "PCデスクを彩る。\nSF好きに刺さるユニーク雑貨。"
  }
];